<template>
  <modal :title="`${platform} Posts Requested`" ref="modal">
    <div class="text-subtitle1">
      The client has been requested to import their {{ platform }} posts into Private Footprint.
    </div>
    <div class="q-mt-md">
      <requested-at :request="request" />
    </div>
    <q-separator class="q-my-md" />
    <info-section :platform="platform" />
    <q-separator class="q-my-md" />
    <reminders-section v-model:request="reconnectRequest" :platform="platform" />
    <q-separator class="q-my-md" />
    <cancel-request-section :request="request" :platform="platform" @canceled="hide()" />
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import Modal from '@/components/modal/Modal.vue';
import { ReconnectRequest } from '@/social/types';
import RemindersSection from './RemindersSection.vue';
import CancelRequestSection from './CancelRequestSection.vue';
import RequestedAt from './RequestedAt.vue';
import InfoSection from './InfoSection.vue';

interface Data {
  reconnectRequest: ReconnectRequest
}

export default defineComponent({
  mixins: [ModalMixin],
  components: {
    RequestedAt,
    Modal,
    RemindersSection,
    CancelRequestSection,
    InfoSection,
  },
  props: {
    request: {
      type: Object as () => ReconnectRequest,
      required: true,
    },
    platform: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      reconnectRequest: { ...this.request },
    };
  },
});
</script>
